import { section } from '@/glow';
import { AnimateBlogPosts } from '@/lib/animation';

section('blog-posts', {
  onLoad() {
    this.AnimateBlogPosts = AnimateBlogPosts(this.container);
  },

  onUnload() {
    this.AnimateBlogPosts?.destroy();
  }
});
